import { createSelector } from 'reselect';

import { selectSensorsCurrent, selectSensorMeta } from '../../store/selectors';

export const selectKeyFromProps = (_, props) => props.dataKey;

const selectSensors = createSelector(
  selectSensorsCurrent,
  selectKeyFromProps,
  (sensors, key) => sensors.filter(
    ({ data }) => data[0] && !!data[0][key],
  ),
);

export const selectReadingsForProps = createSelector(
  selectSensors,
  selectSensorMeta,
  selectKeyFromProps,
  (sensors, meta, key) => sensors.map(sensor => {
    const sensorMeta = meta.find(s => s.lsid === sensor.lsid);
    return {
      lsid: sensor.lsid,
      longitude: sensorMeta.longitude,
      latitude: sensorMeta.latitude,
      value: sensor.data[0][key],
    }
  })
)



// WEBPACK FOOTER //
// ./src/components/DoughnutPlot/selectors.js